import {BuilderFigure} from './character.js';
import {WORLDS} from './levels.js';
import {creatureArtifact as signalPiece} from './artifact.js';
const clamp=x=>Math.max(0,Math.min(1,x)),mix=(a,b,t)=>a+(b-a)*t,smooth=x=>{x=clamp(x);return x*x*(3-2*x);};
const between=(t,a,b)=>smooth((t-a)/(b-a));
const pointMix=(a,b,t)=>a.map((v,i)=>mix(v,b[i],t));
export const PROLOGUE_DURATION=6.4;

export function helmet(r,x,y,a=0){
 const c=r.ctx,ink='#223941';c.save();c.translate(x,y);c.rotate(a);
 c.beginPath();c.moveTo(-10,-6);c.bezierCurveTo(-12,-18,4,-20,10,-9);c.lineTo(11,-6);c.closePath();c.fillStyle='#d4a451';c.fill();c.strokeStyle=ink;c.lineWidth=1.2;c.stroke();
 c.beginPath();c.moveTo(-7,-10);c.quadraticCurveTo(-5,-16,2,-14);c.strokeStyle='#f3ca7d';c.lineWidth=1.7;c.stroke();
 r.path([[-1,-17],[2,-17],[4,-8],[1,-8]],'#b48742');r.path([[-7,-11],[-4,-12],[-3,-8],[-6,-7]],'#586d68',ink,.6);r.line(-6.5,-10,-4,-9,'#d2c9a7',.7);
 r.line(-10,-6,12,-6,'#70583c',4.2);r.line(-10,-7,12,-7,'#f3ca7d',1.5);r.path([[7,-12],[11,-12],[12,-7],[8,-7]],ink);r.line(11,-11,12,-8,'#c4bea0',2.7);r.line(12,-10.5,12.6,-8.4,'#fff2c9',1.8);c.restore();
}
// Authored acting for the discovery, independent of gameplay and its physics.
export function prologuePose(t){
 const hit=.35,fall=between(t,hit,.92),recover=between(t,1.65,2.5),sit=fall*(1-recover);
 const bend=between(t,2.85,3.13)*(1-between(t,3.35,3.72));
 const pocket=between(t,4.33,4.86),lookUp=between(t,5.05,5.85);
 let left=[-11,-18+sit*11],right=[13,-20+sit*11];
 if(t<hit)right=[14,-21-Math.sin(t*15)*5];
 if(t>=hit&&t<1.2){left=[-18,-25+sit*10];right=[19,-23+sit*10];}
 if(t>=1.5&&t<2.5){const lift=between(t,1.7,2.42);left=pointMix([-26,-3],[-6,-42],lift);}
 if(t>=2.85&&t<3.7)right=pointMix([24,-7],[15,-30],between(t,3.14,3.68));
 if(t>=3.7&&t<4.9)right=pointMix([15,-30],[6,-18],pocket);
 if(t>=4.9)right=pointMix([6,-18],[12,-19],between(t,4.9,5.28));
 return{hit,sit,bend,pocket,lookUp,left,right,hatOff:t>=hit&&t<2.45,dazed:t>.65&&t<1.5,questionMarks:t>2.5&&t<5.12,look:lookUp*-1.35,working:t<hit};
}
export class QuarryPrologue{
 constructor(renderer){this.r=renderer;this.figure=new BuilderFigure(renderer);}
 draw(game,t,{zoom=2.5,footY=.72}={}){
  const r=this.r,c=r.ctx,pose=prologuePose(t),u=r.scale/50;
  r.clock=t;r.worldId=0;r.theme=WORLDS[0];r.cameraX=0;r.center=r.w*.46;r.zoom=zoom;
  r.camera=(r.h*.5+(r.h*footY-r.h*.5)/zoom-r.h*.81)/r.scale;
  c.setTransform(r.dpr,0,0,r.dpr,0,0);r.background(game);
  c.save();c.translate(r.center,r.h*.5);c.scale(zoom,zoom);c.translate(-r.center,-r.h*.5);
  r.environment(game);
  const q=r.point(-.12,0),tilt=-Math.sin(between(t,.35,1.15)*Math.PI)*.43;
  const actor={q,unit:u,a:tilt,phase:1,landing:0,harness:q,grip:[0,0],fall:0,facing:1,rope:false,performance:pose};
  // A real workpiece establishes what he was doing before the interruption.
  const bench=r.point(.65,0);r.path([[bench.x-.22*r.scale,bench.y],[bench.x-.19*r.scale,bench.y-.18*r.scale],[bench.x+.19*r.scale,bench.y-.2*r.scale],[bench.x+.25*r.scale,bench.y]],'#617779','#314b52',1);r.line(bench.x-.12*r.scale,bench.y-.18*r.scale,bench.x+.15*r.scale,bench.y-.19*r.scale,'#bbbbb0',1.5);
  this.figure.draw(game,1,actor);
  c.save();c.translate(q.x,q.y);c.scale(u,u);c.rotate(tilt);
  if(pose.hatOff){
    let hx,hy,ha;
    if(t<1.15){const p=clamp((t-.35)/.8);hx=-28*p;hy=-35-28*Math.sin(p*Math.PI)+40*p;ha=-p*4.8;}
    else if(t<1.7){hx=-28;hy=5;ha=-4.8;}
    else{const p=between(t,1.7,2.45);hx=mix(-28,0,p);hy=mix(5,-35,p)-Math.sin(p*Math.PI)*9;ha=mix(-4.8,-Math.PI*2,p);}
    helmet(r,hx,hy,ha);
  }
  let object;
  if(t<.35){const p=t/.35;object=[3,-146+96*p*p,p*.6];}
  else if(t<1){const p=(t-.35)/.65;object=[mix(3,24,p),-50*(1-p)-13*Math.sin(p*Math.PI)-7,p*4.6];}
  else if(t<3.14)object=[24,-7,4.6];
  else if(t<4.33){const p=between(t,3.14,3.68);object=[mix(24,15,p),mix(-7,-31,p),mix(4.6,Math.PI*2,p)];}
  else if(t<4.95)object=[mix(15,6,pose.pocket),mix(-31,-15,pose.pocket),Math.PI*2];
  if(object){
    c.save();
    if(pose.pocket>.5){c.beginPath();c.rect(-100,-200,200,180);c.clip();}
    signalPiece(r,...object);c.restore();
  }
  // The object is visibly occluded by the pocket lip, followed by the hand.
  if(pose.pocket>.5){r.line(3,-20,10,-20,'#263f46',1.4);r.line(3,-19.2,10,-19.2,'#ecc58b',.65);r.circle(...pose.right,2.2,'#e6c194','#223941',.6);}
  if(pose.questionMarks){
    c.save();c.globalAlpha=between(t,2.5,2.7)*(1-between(t,4.83,5.12));
    for(const [x,y,s] of [[-10,-67,.75],[2,-73,1],[14,-67,.7]]){c.save();c.translate(x,y);c.scale(s,s);r.path([[-3,-5],[-1,-7],[2,-7],[4,-5],[3,-2],[0,0],[0,3]],null,'#fff1ce',1.7,false);r.circle(0,7,.9,'#fff1ce');c.restore();}
    c.restore();
  }
  c.restore();c.restore();
  return{time:t,beat:t<.35?'work':t<1.5?'bonk':t<2.5?'hat':t<4.33?'inspect':t<5.05?'pocket':'look-up',objectPocketed:t>=4.95,hatOn:!pose.hatOff};
 }
}
